<div *ngIf="isBaseAdminRoute()" class="admin-dashboard-container">
  <div class="header">
    <h1>Admin Dashboard</h1>
    <p>Select a client to view their details</p>
  </div>

  <div class="content">
    <div class="dashboard-main-content">
      <div class="section clients-section">
        <h2>Available Clients</h2>

        <div *ngIf="isLoadingClients" class="loading">
          <div class="spinner"></div>
          <p>Loading clients...</p>
        </div>

        <div *ngIf="!isLoadingClients" class="clients-table-container">
          <table class="clients-table">
            <thead>
              <tr>
                <th>Name</th>
                <th class="actions-header">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let client of clients"
                  class="client-row"
                  [class.busy]="isBusy(client.id)"
                  tabindex="0"
                  (click)="onRowClick(client)"
                  (keydown.enter)="onRowKeydown($event, client)">
                <td>{{ client.name }}</td>
                <td class="actions-cell">
                  <button mat-icon-button
                          type="button"
                          title="Rename client"
                          aria-label="Rename client"
                          (click)="$event.stopPropagation(); openRenameDialog(client)"
                          [disabled]="isBusy(client.id)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button
                          type="button"
                          color="warn"
                          title="Delete client"
                          aria-label="Delete client"
                          (click)="$event.stopPropagation(); openDeleteDialog(client)"
                          [disabled]="isBusy(client.id)">
                    <mat-icon>delete</mat-icon>
                  </button>
                  <button mat-icon-button
                          type="button"
                          color="primary"
                          title="Select client"
                          aria-label="Select client"
                          (click)="$event.stopPropagation(); selectClient(client.id)"
                          [disabled]="isLoadingClientDetails || isBusy(client.id)">
                    <mat-icon>arrow_forward</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>
